// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuestionsBlock_wrapper__fOaJb","header":"QuestionsBlock_header__qYttH","button":"QuestionsBlock_button__sPpG_"};